import {API} from '../API';
import PaginatedList from '../PaginatedList';
import Plant from '../../models/Plant';
import {store} from '../../redux/StoreReducers';

const PlantsApiService =  {
    get: async (pageNumber = 1, keyword = '') => {
        const {data: response} = await API.get(
            `/varieties/paginatedPlants?page=${pageNumber}&search=${keyword}`,
        );

        const list = new PaginatedList();
        list.items = response.data.map((plant) => new Plant(plant));
        list.page = response.meta.page;
        list.pageCount = response.meta.lastPage;
        list.pageSize = response.meta.perPage;
        list.total = response.meta.total;
        return list;    
    },

    detail: async (id) => {
        const {data: response} = await API.get(`/varieties/plant/${id}`);
        const plant = new Plant(response.data);
        return plant;
    },

    save: async (params, state) => {
        await API.post(`/varieties/plant/`, params, {
            headers: {'Accept-Language': store.getState().langReducer.lang},
        });

        return {};
    },

    update: async (id, params) => {
        const {data: response} = await API.put(`/varieties/plant/${id}`, params);
        return {plant: new Plant(response.data)};
    },

    delete: async (id) => {
        await API.delete(`/varieties/plant/${id}`);
        return {};
    },
}

export default PlantsApiService;